export const SALE_REPORT_LIST_INITING = 'SALE_REPORT_LIST_INITING'
export const SALE_REPORT_LIST_REQUESTING = 'SALE_REPORT_LIST_REQUESTING'
export const SALE_REPORT_LIST_SUCCESS = 'SALE_REPORT_LIST_SUCCESS'
export const SALE_REPORT_LIST_ERROR = 'SALE_REPORT_LIST_ERROR'

export const SALE_REPORT_NVKD_REQUESTING = 'SALE_REPORT_NVKD_REQUESTING'
export const SALE_REPORT_NVKD_SUCCESS = 'SALE_REPORT_NVKD_SUCCESS'
export const SALE_REPORT_NVKD_ERROR = 'SALE_REPORT_NVKD_ERROR'

export const SALE_REPORT_KH_REQUESTING = 'SALE_REPORT_KH_REQUESTING'
export const SALE_REPORT_KH_SUCCESS = 'SALE_REPORT_KH_SUCCESS'
export const SALE_REPORT_KH_ERROR = 'SALE_REPORT_KH_ERROR'

export const SALE_REPORT_EXPORT_XLS_REQUESTING = 'SALE_REPORT_EXPORT_XLS_REQUESTING'
export const SALE_REPORT_EXPORT_XLS_SUCCESS = 'SALE_REPORT_EXPORT_XLS_SUCCESS'
export const SALE_REPORT_EXPORT_XLS_ERROR = 'SALE_REPORT_EXPORT_XLS_ERROR'

export const SALE_REPORT_KH_BY_NHOM_REQUESTING = 'SALE_REPORT_KH_BY_NHOM_REQUESTING'
export const SALE_REPORT_KH_BY_NHOM_SUCCESS = 'SALE_REPORT_KH_BY_NHOM_SUCCESS'
export const SALE_REPORT_KH_BY_NHOM_ERROR = 'SALE_REPORT_KH_BY_NHOM_ERROR'

export const SALE_REPORT_NHOMKH_REQUESTING = 'SALE_REPORT_NHOMKH_REQUESTING'
export const SALE_REPORT_NHOMKH_SUCCESS = 'SALE_REPORT_NHOMKH_SUCCESS'
export const SALE_REPORT_NHOMKH_ERROR = 'SALE_REPORT_NHOMKH_ERROR'

export const SALE_REPORT_NVKD_API = '/api/v1/users/get_list_by_quanly'
export const SALE_REPORT_KH_API = '/api/v1/khachhang/KhachByNvkd'
export const SALE_REPORT_LIST_API = '/api/v1/report/baoCaoDoanhSo'
export const SALE_REPORT_EXPORT_XLS_API = '/api/v1/report/bao_cao_doanh_so_export_by_store'
export const SALE_REPORT_NHOMKH_API = '/api/v1/nhomkhachhang/nhomkhachhang_list_actived_by_store'
export const SALE_REPORT_KH_BY_NHOM_API = '/api/v1/khachhang/khachhangByNhomOrNvkd'


// WEBPACK FOOTER //
// ./src/views/Reports/SaleReport/constants.js